import {CURRENCIES, RoundedMoney} from '@pb/kit-component-formatters';

import type {Locale} from '@pb/kit-context-locale';


type Config = {
    showSymbol?: boolean,
    hideTrailingZeros?: boolean,
};
export const getCost = (amount: number, locale: Locale, {showSymbol, hideTrailingZeros}: Config = {}) =>
    RoundedMoney.format(amount, {...locale, currency: CURRENCIES.USD}, {
        preventRound: true,
        showSymbol,
        hideTrailingZeros,
    });
